import { render } from "./WikipediaView.vue?vue&type=template&id=68ffa408"
import script from "./WikipediaView.vue?vue&type=script&lang=js"
export * from "./WikipediaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__